import { inject, observer } from 'mobx-react';
import * as React from 'react';
import RoamingStore from '../../../stores/RoamingStore';
import { TranslationsContext } from '@teliaee/telia-translate';
import { Segment, SEGMENT_PRIVATE } from '../../../stores/SegmentStore';
import { formatRoamingServicePrice, renderAddedVat } from '../../../util/PriceUtil';
import { GroupService } from '../../RoamingInterfaces';

interface ServicePriceItemProps {
  segment: Segment;
  service: GroupService;
  roamingStore?: RoamingStore;
}

@observer
class ServicePriceItem extends React.Component<ServicePriceItemProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;
  public render() {
    const translate = this.context.translate;
    const { service, segment } = this.props;
    const priceValue = this.getPriceValue(service);
    return `${formatRoamingServicePrice(priceValue)} ${this.getPricingUnit(service)}${segment === 'BUSINESS' ? renderAddedVat(translate) : ''}`;
  }

  private getPricingUnit(service: GroupService) {
    const translate = this.context.translate;
    if (!service.servicePrices || !service.servicePrices.length) {
      return null;
    }
    const priceUnit = service.servicePrices[0].priceUnit;
    switch (priceUnit) {
      case 'TIME':
        return translate('roaming.operator.price-per-minute');
      case 'DATA':
        return translate('roaming.operator.price-per-mb');
      case 'CNT':
        return translate('roaming.operator.price-per-count');
      default:
        return '';
    }
  }

  private getPriceValue(service: GroupService) {
    return this.props.segment === SEGMENT_PRIVATE ? service.servicePrices[0].priceValue : service.servicePrices[0].priceValueWoVat;
  }
}

export default inject('roamingStore')(ServicePriceItem);
